import React from "react";
import Icon from "components/CommonIcon/Icon";
import cx from "classnames";

const DrawerHead = ({ onClose, title, className }) => {
  return (
    <div
      className={cx(
        "grid grid-cols-3 border border-solid border-gray-light py-20 pl-20 bg-white",
        className
      )}>
      <div className="col-span-1 text-left cursor-pointer" onClick={onClose}>
        <Icon name="close" fontSize="text-16" />
      </div>
      <div className="col-span-2 md:col-span-1 font-semibold text-m-h4 text-left md:text-center">
        {title}
      </div>
    </div>
  );
};

export default DrawerHead;
